import { BaseService } from '@/core/base-service';

export default class QuestionDetailService extends BaseService<any> {
  public constructor() {
    super('services/serviceauttech/api/question-detail');
  }
}
